<span class="flex items-center w-full h-full">
    <button mat-icon-button (click)="onClick()" [matTooltip]="params.tooltip"><mat-icon class="mb-2">{{ params.icon }}</mat-icon></button>
</span>
